export {
  default as permissionReducer,
  selectHasPermission,
  permit,
  deny,
} from './permission-slice'
